<template>
  <section class="addressEdit">
    <header-com/>
    <div class="topWrap">
      <ul>
        <li>
          <h3>收货人：</h3>
          <div>
            <input type="text" placeholder="请填写收货人姓名" v-model="name">
          </div>
        </li>
        <li>
          <h3>手机号：</h3>
          <div>
            <input type="tel" placeholder="请填写收货人手机号" v-model="tel" oninput="if(value.length>11)value=value.slice(0,11)">
          </div>
        </li>
        <li @click='show = true'>
          <h3>收货地址：</h3>
          <div class="selectAddress">
            <p class="grey9 f28">{{adressNames[0] + adressNames[1] + adressNames[2] }}</p>
          </div>
        </li>
        <li>
          <h3>门牌号：</h3>
          <div>
            <input type="text" placeholder="请填写详细地址" v-model="adress" @blur="inputBlur">
          </div>
        </li>
      </ul>
    </div>
    <div class="midWrap">
      <span class="f28 bold">设为默认地址</span>
      <my-switch @change-switch='changeSwitch' :checkSwitch='isDefault'/>
    </div>
    <div class='adrTips' :class='{adrTipsI : isIPX}' v-if='ins == "bag"'>*{{$store.state.takeSendCity}}、沈阳、重庆{{$store.state.takeSendNum}}城包邮</div>
    <div class="g-fixed-bottom t_right">
      <button class="primary"  @click="saveAddress">保存地址</button>
      <button class="secondary" v-if='addressId' @click='delAdress'>删除</button>
      
    </div>
    <van-popup v-model="show" position="bottom" :overlay="true" >
      <van-picker :columns="columns" 
        @change="onChange" 
        show-toolbar
        @cancel="show = false"
        @confirm="onConfirm"

      />
    </van-popup>
  </section>
</template>

<script>
  import { Toast ,Dialog} from 'vant';
  import myApi from '@/axios/my'
  import publicObj from '@/assets/js/public'
  import zhugeObj from '@/assets/js/track';
  export default {
    name: 'addressEdit',
    components: {},
    data () {
      return {
        columns: [
          {
            values: [],
          },
          {
            values: [],
            defaultIndex: 0
          },
          {
            values: [],
            defaultIndex: 0
          }
        ],
        show : false,
        isDefault : false,
        addressId : '',
        name : '',
        tel : '',
        adress : '',
        provinceList : [],
        cityList : [],
        quList : [],
        adressNames : ['点击选择','',''],
        adressIndexs:[],
        ins : 'nobag',
        isIPX:false,
      }
    },
    watch: {},
    computed: {},
    created () {
      this.isIPX=publicObj.isIPX()
      this.addressId = this.$route.query.aid;
      if(this.addressId) this.getDetail(this.addressId);
      this.getProvince();
      this.ins = this.$route.query.ins;
    },
    mounted () {
     
    },
    methods: {
      inputBlur(){
        publicObj.IPhoneXHack()
      },
      getProvince(){
        let arr = [];
        myApi.getProvince({}).then((res)=>{
          this.provinceList = res;
          res.forEach(element => {
            arr.push(element.areaName);
          });
          this.columns[0].values = arr;
          let params1 = {
            code : res[0].code,
            NO_LOADING : true
          }
          myApi.getCity(params1).then((res)=>{
            let arr1 = []
            res.forEach((element)=>{
              arr1.push(element.areaName);
            })

            this.columns[1].values = arr1;
            this.cityList = res;
            let params = {
              code : res[0].code,
              NO_LOADING : true
            }
            myApi.getCity(params).then((res)=>{
              let arr2 = []
              res.forEach((element)=>{
                arr2.push(element.areaName);
              })
              
              this.columns[2].values = arr2;
              this.quList = res;
            })
          })
        })
      },
      onConfirm(value, index){
        this.adressNames = value;

        this.provinceList.forEach((element,idx)=>{
          if(idx == index[0]){
            this.$set(this.adressIndexs,0,element.code);
            
          }
        })

        this.cityList.forEach((element,idx)=>{
          if(idx == index[1]){
            this.$set(this.adressIndexs,1,element.code);
          }
        })

        this.quList.forEach((element,idx)=>{
          if(idx == index[2]){
            this.$set(this.adressIndexs,2,element.code);
          }
        })

        
        this.show = false;
      },
      //第二行获取数据
      changeTwoList(picker,values){
        this.provinceList.forEach((element)=>{
          if(element.areaName == values){
            let arr = [];
            let params = {
              code : element.code,
              NO_LOADING : true
            }
            myApi.getCity(params).then((res)=>{
              res.forEach((element)=>{
                arr.push(element.areaName);
              })

              picker.setColumnValues(1,arr);
              this.cityList = res;
              this.changeThreeList(picker,arr[0])
            })
          }
        })
      },

      changeThreeList(picker,values){
        this.cityList.forEach((element)=>{
          if(element.areaName == values){
            let arr = [];
            let params = {
              code : element.code,
              NO_LOADING : true
            }
            myApi.getCity(params).then((res)=>{
              res.forEach((element)=>{
                arr.push(element.areaName);
              })

              picker.setColumnValues(2,arr);
              this.quList = res;
            })
          }
        })
      },

      onChange(picker, values , index) {
        console.log(picker, values , index);
        //改变第一列
        if(index == 0){
          this.changeTwoList(picker,values[0])
        }else if(index == 1){
          this.changeThreeList(picker,values[1])
        }

      },
      changeSwitch(){
        this.isDefault = !this.isDefault;
      },
      getDetail(id){
        myApi.customerAddressById(id).then((res)=>{
            this.name = res.contacts;
            this.tel = res.mobile;
            this.adress = res.address;
            this.isDefault = res.isDefault;
            this.$set(this.adressNames,0,res.province);
            this.$set(this.adressNames,1,res.city);
            this.$set(this.adressNames,2,res.district);
            this.$set(this.adressIndexs,0,res.provinceCode);
            this.$set(this.adressIndexs,1,res.cityCode);
            this.$set(this.adressIndexs,2,res.districtCode);
        })
      },
      delAdress(){
        Dialog.confirm({
          title: '',
          message: '是否确定删除该地址？'
        }).then(() => {
          myApi.delAdress(this.addressId).then((res)=>{
            this.$router.push({name:'addressList'});
          })
        }).catch(() => {
          // on cancel
        });
      },
      saveAddress () {
        
        if(!this.name) {
          Toast('请填写姓名');
          return;
        }
        if(!this.tel) {
          Toast('请填写正确手机号码');
          return;
        }

        if(this.adressIndexs.length < 3) {
          Toast('请选择地址');
          return;
        }

        if(!this.adress) {
          Toast('请填写门牌号');
          return;
        }


        let params = {
          contacts : this.name,
          mobile  : this.tel,
          provinceCode : this.adressIndexs[0],
          province : this.adressNames[0],
          cityCode : this.adressIndexs[1],
          city : this.adressNames[1],
          districtCode : this.adressIndexs[2],
          district : this.adressNames[2],
          address : this.adress,
          isDefault : this.isDefault
        }
        this.quList.forEach((element)=>{
          if(element.id == this.adressIndexs[2]){
            
            params.addressCode = element.code;
          } 
        })
        if(this.addressId){
          this.editAdress(params);
          return;
        }
        myApi.addAdress(params).then((res)=>{
          zhugeObj.track({
            title : '我的地址',
            content : {
              '添加地址' : '成功',
            }
          })
          this.$router.back();
        }).catch(()=>{
          zhugeObj.track({
            title : '我的地址',
            content : {
              '添加地址' : '失败',
            }
          })
        })
      },
      editAdress(params){
        params.id = this.addressId;
        myApi.editAdress(params).then((res)=>{
          zhugeObj.track({
            title : '我的地址',
            content : {
              '修改地址' : '成功',
              '修改的地址ID' : this.addressId
            }
          })
          this.$router.back();
        }).catch(()=>{
          zhugeObj.track({
            title : '我的地址',
            content : {
              '修改地址' : '失败',
              '修改的地址ID' : this.addressId
            }
          })
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .adrTipsI{
    bottom:130px!important;
  }
  .adrTips{
      background: #F3FBFB;
      padding:16px 30px;
      color:#4A4A4A;
      font-size: 24px;
      position: fixed;
      bottom:110px;
      left:0;
      line-height: 40px;
  }
  .primary{
    position: absolute;
    right: 30px;
    top:9px;
  }
  .secondary{
    position: absolute;
    right: 270px;
    top:14px;
  }

  .addressEdit{
    padding: 100px 20px;
    .topWrap{
      background: $white-color;
      border-radius: $base-radius;
      box-shadow: $base-shadow;
      padding: 16px 20px 58px;
      margin-bottom: 20px;
      li{
        display: flex;
        padding-top: 40px;
        h3,input{font-size: 28px;}
        h3{
          width: 140px;
          line-height: 40px;
        }
        div{
          padding: 0 20px 14px 16px;
          width: 530px;
          box-sizing: border-box;
          line-height: 40px;
          border-bottom: 2px $border-color dashed;
          input{
            width: 100%;
            line-height: 40px;
          }
        }
        .selectAddress{
          background: url("/images/public/arrow_right.png") no-repeat 97% 10px;
          background-size: 12px;
        }
      }
    }
    .midWrap{
      padding: 24px 28px;
      box-shadow: $base-shadow;
      border-radius: $base-radius;
      height: 44px;
      line-height: 44px;
      display: flex;
      justify-content: space-between;
    }
    button{
      margin-left: 20px;
    }
  }
</style>
